import React, { useState } from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const MessageExtensionTimeoutError = (props) => {
  return (
    <>
      <Paragraph>
        The detection browser extension was not installed from the Chrome Web Store, and no data was gathered to
        accurately analyze this computer.
      </Paragraph>
      <Paragraph>The extension must be installed to continue.</Paragraph>
      <Paragraph>You can retry the extension installation (recommended) or cancel the detection.</Paragraph>
    </>
  );
};

export default MessageExtensionTimeoutError;
